import React from 'react';
import {
  Card,
  CardMedia,
  CardTitle,
  Typography,
} from '@one-thd/sui-atomic-components';

export const ShopAllCard = ({ item, titleSize = '2.2rem' }) => (
  <Card
    href={`${item.link}?emt=ppsrc_2603`}
    className="sui-h-full sui-w-full sui-border sui-border-primary"
    CardContentProps={{ className: 'sui-flex sui-p-4 sui-gap-4 sui-flex-col sui-h-full' }}
  >
    <div className="sui-flex sui-flex-col sui-h-full">
      <div className="sui-flex-1 sui-content-center">
        <CardMedia
          src={item.imageUrl}
          alt={item.description}
          padding
          loading="lazy"
        />
      </div>
      <CardTitle
        header={(
          <Typography variant="h3" weight="bold" style={{ fontSize: titleSize }}>
            {item.description}
          </Typography>
        )}
      />
    </div>
  </Card>
);